import styled from 'styled-components';
import device from '../../../../GlobalDigitalStyle/BreakPoint.style';

export const HomeTeamsContainer = styled.div`
	.home__headers {
		font-weight: 700;
		.header__toggle__tab {
			padding: 1.5em 2em;
			@media ${device.screen1440} {
				padding: 1.5em;
			}
			@media ${device.screen1366} {
				padding: 1.5em 1em;
			}
			@media ${device.screen1050} {
			}
		}
	}
	.tournaments__standing {
		height: 20em;
		.tournament__standing {
			height: 20em;
			.standings__cell {
			}
		}
	}
	.my__tournaments__ranks {
		tbody{
            tr{
                td{
                    padding: 1em 0;
                }
            }
        }
	}
	.text__default {
		font-weight: 600;
		font-size: 15px;
		@media ${device.screen1680} {
			font-size: 14px;
		}
		@media ${device.screen1280} {
			font-size: 12.8px;
		}
		@media ${device.screen1050} {
			font-size: 11px;
		}
	}
`;
